module.exports = __webpack_public_path__ + "static/img/bg.6eed593.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/bg.jpg
// module id = FAVF
// module chunks = 0